var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M4.5 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4 5.8a8 8 0 0 1 6.929 3.999A11.95 11.95 0 0 1 8.5 16c-2.581 0-4.972-.815-6.929-2.201A8 8 0 0 1 8.5 9.8",
    clipRule: "evenodd"
  })));
};
export { SvgUser as ReactComponent };